import React from 'react';
import Select from 'react-select';
import { ReportSelectOptionType } from '../../../types/reports';
import './VertNavSearchBox.scss';

interface VertNavSearchBoxProps {
  reportOptions: ReportSelectOptionType[];
  selectedOption: ReportSelectOptionType | null;
  onChange: (selected: ReportSelectOptionType | null) => void;
}

export const VertNavSearchBox: React.FC<VertNavSearchBoxProps> = ({
  reportOptions,
  selectedOption,
  onChange,
}) => (
  <div className="mx-2 vert-nav-search-sticky">
    <Select
      isSearchable
      isClearable
      options={reportOptions}
      name="label"
      value={selectedOption}
      onChange={onChange}
      classNamePrefix="fmsr-select"
      placeholder={'Search reports...'}
    />
  </div>
);
